import { TeflOlComment } from '../../../lib/types/models/tefl-ol-comment/tefl-ol-comment'
import { TeflOlCommentRequest } from '../../../lib/types/models/tefl-ol-comment/tefl-ol-comment-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createTeflOlComment = async (input: TeflOlCommentRequest & { teflId: number }) => {
  const { teflId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.tefl.createTeflOlComment.url, { teflId }))
    .post<TeflOlComment, TeflOlCommentRequest>(data)
}
